module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-1200-1055e7c549bb7a21ed12d8c0905e8063.webp";